import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

export default class GlobalCustomerPricing extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: '',
            customerPricing: '',
            loading: false,
            showBorder: this.props.showBorder,
        };
        console.log(this.props);
    }

    handleChange = (e) => {
        this.setState({
            error: '',
            customerPricing: e.target.value,
        });
    };

    handleSubmit = () => {
        if (this.state.customerPricing === '' || this.state.customerPricing === 0) {
            this.setState({
                error: 'Please fill in the required field',
            });

            return;
        }

        this.setState({
            loading: true,
        });

        let formData = new FormData();
        formData.append('customer_pricing', this.state.customerPricing);

        axios
            .post(this.props.url, formData)
            .then((res) => {
                toastr.success('Customers pricing update');
                this.setState({
                    loading: false,
                });
            })
            .catch(() => {
                toastr.error('Failed to update customers pricing');
                this.setState({
                    loading: false,
                });
            });
    };

    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="card-body">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label htmlFor="customers-pricing" className="d-block">
                                    Change customer pricing
                                </label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="inputGroupPrepend2">
                                            %
                                        </span>
                                    </div>
                                    <input
                                        type="number"
                                        min="0.01"
                                        step="0.01"
                                        id="customers-pricing"
                                        className="form-control"
                                        value={this.state.customerPricing}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                {this.state.error ? <p className="text-danger">{this.state.error}</p> : ''}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <button
                                className="btn btn-cw-primary"
                                onClick={this.handleSubmit}
                                style={{ minWidth: '175px' }}
                            >
                                {this.state.loading ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    'Edit Customers Pricing'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('global-customer-pricing')) {
    let element = document.getElementById('global-customer-pricing');

    ReactDOM.render(
        <GlobalCustomerPricing
            url={element.dataset.url}
            title={element.dataset.title}
            showBorder={element.dataset.show_border}
        />,
        element
    );
}
